import { mainLayoutApi } from "../api/mainLayout.api";
import { TransactionUpdateReadRequest } from "../models/Request/transactionUpdateReadRequest";
import { TransactionUpdateStatusResponse } from "../models/Response/transactionUpdateStatusResponse";
import { UnifiedResponse } from "../models/Response/unifiedResponse";
import errorModal from "./errorModal.service";

export const mainLayoutService = {
  fetchTransactionUpdate: async (): Promise<UnifiedResponse<TransactionUpdateStatusResponse>> => {
    return await mainLayoutApi.fetchTransactionUpdate();
  },

  markTransactionAsRead: async (request: TransactionUpdateReadRequest) => {
    var response = await mainLayoutApi.transactionUpdateReadStatus(request);

    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }

    return response;
  },
};